var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-circle-wrapper',{on:{"click":function($event){return _vm.$emit('emit', $event)}}},[_c('base-questions-icon',{attrs:{"fill":"#4B5563"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }